<template>
  <v-app v-if="layoutReady" dark>
    <CustomerNavbar />
    <v-main>
      <v-container fluid>
        <slot />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { isLoggedInWithRole } from "@/lib/auth";

import Footer from "@/components/Footer.vue";
import { AuthRole } from "@/typings/auth";
import CustomerNavbar from "./customer/CustomerNavbar.vue";

const router = useRouter();
const route = useRoute();
const layoutReady = ref(false);

onBeforeMount(() => {
  if (!isLoggedInWithRole(AuthRole.customer)) {
    router.push({ name: "login", query: { redirect: route.fullPath } });
    return;
  }
  layoutReady.value = true;
});
</script>
